import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {

  modalState = new Subject<any>();

  open(
    title: string,
    message: string,
    onConfirm: () => void,
    confirmText: string = 'Confirm',
    cancelText: string = 'Cancel'
  ) {
    this.modalState.next({
      show: true,
      title,
      message,
      confirmText,
      cancelText,
      onConfirm
    });
  }

  close() {
    this.modalState.next({
      show: false
    });
  }
}